export default "__VITE_ASSET__TKGIGciv__"